// extracted by mini-css-extract-plugin
export var chatHtmlText = "_p5-2";
export var chatLink = "_p5-0";
export var chatText = "_p5-1";